/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * The tabs of the People panel.
 */
export enum PeopleTab {
  ATTENTION = "attention",
  ONBOARDING = "onboarding",
  ALL = "all",
  STUDENT = "student",
  PARENT = "parent",
  TUTOR = "tutor",
}
